module.exports = __webpack_public_path__ + "static/story3-menu-thumbnails-400x400-f3d84e692613749218c2fbf4f9cd49b4.jpg";